export default function CTASection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = useCallback(async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('订阅成功！我们会不定期发送高质量的行动力内容到你的邮箱。');
      setEmail('');
      return;
    }

    setStatus('loading');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      formData.forEach((value, key) => {
        if (key !== 'phone_alt' && key !== 'email') {
          payload.append(key, value as string);
        }
      });

      const res = await fetch('https://readdy.ai/api/form/d9re5fknlsngrm4lmb2g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！我们会不定期发送高质量的行动力内容到你的邮箱。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText;
        if (typeof serverMsg === 'string' && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
          setStatus('success');
          setMessage('订阅成功！我们会不定期发送高质量的行动力内容到你的邮箱。');
          setEmail('');
        } else {
          setStatus('error');
          setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后再试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  }, [email]);

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 relative overflow-hidden" aria-labelledby="cta-title">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20circles%20in%20amber%20and%20coral%20tones%2C%20smooth%20texture%2C%20modern%20minimalist%20design%2C%20clean%20and%20inspiring%20atmosphere%2C%20no%20text&width=1600&height=600&seq=jiuqugan-cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/90 via-primary-800/85 to-accent-900/90"></div>

      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 id="cta-title" className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好「就去干」了吗？
        </h2>
        <p className="text-background-50/70 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
          订阅我们的行动力通讯，每周获取最新的方法论、实战技巧和真实故事，帮你保持行动状态。
        </p>

        {status === 'success' ? (
          <div className="flex items-center justify-center gap-3 text-background-50 bg-white/10 rounded-full px-6 py-4 backdrop-blur-sm max-w-md mx-auto">
            <i className="ri-check-line text-accent-400 text-xl w-5 h-5 flex items-center justify-center"></i>
            <p className="text-sm font-medium">{message}</p>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="antispam-field"
            />
            <div className="relative flex-1 w-full">
              <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-background-50/40 text-sm w-4 h-4 flex items-center justify-center"></i>
              <input
                type="email"
                name="email"
                required
                placeholder="输入你的邮箱地址"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-4 py-3.5 rounded-full bg-white/15 border border-white/20 text-background-50 placeholder:text-background-50/40 text-sm outline-none focus:border-accent-400 focus:bg-white/20 transition-all duration-300"
              />
            </div>
            <button
              type="submit"
              disabled={status === 'loading'}
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-background-50 font-semibold rounded-full text-sm transition-all duration-300 whitespace-nowrap disabled:opacity-60 cursor-pointer"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </form>
        )}

        {status === 'error' && (
          <p className="mt-3 text-xs text-red-300">{message}</p>
        )}

        <p className="mt-5 text-xs text-background-50/40">
          每周一封邮件，随时可退订。我们尊重你的注意力。
        </p>
      </div>
    </section>
  );
}